import type { BaseVenue, Teacher } from '../../../App.types'

import ActiveTeacherCard from './ActiveTeacherCard'
import DisabledTeacherCard from './DisabledTeacherCard'

export interface Props {
  teacher: Omit<Teacher, 'recentlyTrainedUserAt'>
  venue: BaseVenue | null
}

const TeacherCard = ({ teacher, venue }: Props) => {
  return !venue || !venue.offerings.length ? (
    <DisabledTeacherCard teacher={teacher} venue={venue} />
  ) : (
    <ActiveTeacherCard teacher={teacher} venue={venue} />
  )
}

export default TeacherCard
